import { injectable, decorate, inject } from 'inversify';
import 'reflect-metadata';
import { SERVICE_IDENTIFIER } from 'constants/identifiers';
import { NetworkError, UserError } from 'errors';
import userStore from 'stores/UserStore';

@injectable()
class UserProfileService {
  constructor(apiService) {
    this.apiService = apiService;
  }

  async getUserAnalytics() {
    try {
      const result = await this.apiService.get('/analytics');
      const data = result.data.data.items[0];

      // Save sales plans to userStore
      if (data?.salesPlans) {
        userStore.setUser({ salesPlans: data.salesPlans });
      }

      return data;
    } catch (e) {
      if (e instanceof NetworkError) {
        throw new UserError(e.message);
      }
      throw e;
    }
  }

  async getAccountData() {
    try {
      const result = await this.apiService.get('/user');
      return result.data.data.items[0];
    } catch (e) {
      if (e instanceof NetworkError) {
        throw new UserError(e.message);
      }
      throw e;
    }
  }

  async sendSalesPlans(data) {
    try {
      await this.apiService.post('/user/sales-plans', data);
    } catch (e) {
      if (e instanceof NetworkError) {
        throw new UserError(e.message);
      }
      throw e;
    }
  }
}

decorate(inject(SERVICE_IDENTIFIER.ApiService), UserProfileService, 0);

export default UserProfileService;
